
export class ClientNameResponse {
    clientId: number;
    name: string;
}